import React, { useState } from "react"
import { Spin } from "antd"
import styles from "../ResortApartments/resortApartments.module.scss"
import { Intersection } from "../../Intersection/Intersection"

export function Preview3D({ url }) {
    if (!url) {
        return null
    }
    const Render = ({ active }) => {
        const [loading, setLoaded] = useState(true)
        return (
            <>
                {loading && (
                    <div className={styles.previewLoading}>
                        <Spin size="large" className={styles.spinner} />
                    </div>
                )}
                {active && (
                    <div className={styles.previewContent}>
                        <iframe
                            loading="lazy"
                            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                            onLoad={() => setLoaded(false)}
                            className={styles.iframe}
                            data-loading={loading || undefined}
                            width="1280"
                            height="360"
                            src={url}
                            frameBorder="0"
                            allowFullScreen
                            id="showcase_iframe"
                        />
                        3d walkthrough courtesy of dvcrequest.com
                    </div>
                )}
            </>
        )
    }
    return <Intersection once render={Render} />
}
